import React from 'react'
import { useField } from 'formik'

import {
  MultiSelectFieldPropsType,
  WithMultiSelectFieldPropsType,
} from './interface'

export function withMultiSelectField(
  Component: React.FC<MultiSelectFieldPropsType>
) {
  function WithMultiSelectField({
    name,
    ...props
  }: WithMultiSelectFieldPropsType) {
    const [field, , { setValue }] = useField(name)

    function handleRemove(value: string) {
      const index = field.value.findIndex((row: string) => row === value)

      if (index !== -1) {
        const temp = [...field.value]
        temp.splice(index, 1)

        setValue(temp)
      }
    }

    const pageProps = {
      ...props,
      ...field,
      handleRemove,
    }
    return <Component {...pageProps} />
  }
  WithMultiSelectField.defaultProps = {
    isInputLabel: false,
  }

  return WithMultiSelectField
}
